var swiper = new Swiper('.carrossel-clientes', {
    grabCursor: true,
    loop: true,
    speed: 700,
    spaceBetween: 30,
    slidesPerView: 2,
    autoplay: {
        delay: 2000,
        pauseOnMouseEnter: true
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    breakpoints: {
        560: {
            slidesPerView: 4
        },
        991: {
          slidesPerView: 5
        }         
    }
});
var swiper = new Swiper('.carrossel-ferramentas', {
    grabCursor: true,
    loop: true,
    speed: 700,
    spaceBetween: 30,
    slidesPerView: 1,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    breakpoints: {
        560: {
            slidesPerView: 2
        },
        991: {
          slidesPerView: 3
        }         
    }
});
var swiper = new Swiper('.carrossel-cases', {
    grabCursor: true,
    loop: true,
    speed: 700,
    slidesPerView: 1,
    autoplay: {
        delay: 5000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});

var swiper = new Swiper('.carrossel-depoimentos', {
    grabCursor: true,
    loop: true,
    speed: 700,
    slidesPerView: 1,
    autoplay: {
        delay: 5000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});

var swiper = new Swiper('.carrossel-videos', {
    effect: 'coverflow',
    loop: true,
    grabCursor: false,
    initialSlide: 1,
    speed: 700,
    centeredSlides: true,
    slidesPerView: 'auto',
    slideToClickedSlide: true,
    preventInteractionOnTransition: true,
    autoplay: {
        delay: 10000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
    },
    coverflowEffect: {
        depth: 500,
        modifier: 1,
        rotate: 0,
        scale: 1,
        stretch: 80,
        slideShadows: true
    },
    navigation: {
        nextEl: ".carrossel-videos-next",
        prevEl: ".carrossel-videos-prev",
    }
});

// Função para verificar se o elemento está visível na viewport
function elementoVisivel(el) {
    var $rect = el.getBoundingClientRect();
    var $windowHeight = window.innerHeight || document.documentElement.clientHeight;
    var $windowWidth = window.innerWidth || document.documentElement.clientWidth;

    var $rectTop = $rect.top;
    var $rectLeft = $rect.left;
    var $rectBottom = $rect.bottom;
    var $rectRight = $rect.right;

    return (
        $rectTop >= 0 &&
        $rectLeft >= 0 &&
        $rectBottom <= $windowHeight &&
        $rectRight <= $windowWidth
    );
}

// Função para iniciar o contador quando o elemento estiver visível
function iniciarContador(elemento) {
    var valorAtual = 0;
    var valorFinal = parseInt(elemento.getAttribute("data-valor"), 10);
    var incremento = Math.ceil(valorFinal / 100); // Ajuste o incremento conforme necessário

    var contador = setInterval(function() {
        if (valorAtual < valorFinal) {
            valorAtual += incremento;
            elemento.textContent = Math.min(valorAtual, valorFinal); // Evita ultrapassar o valor final
        } else {
            clearInterval(contador);
        }
    }, 30); // Intervalo entre cada incremento (em ms)
}

// Função para verificar todos os elementos `.nbr` e iniciar contagem se estiverem visíveis
function checarVisibilidade() {
    var elementos = document.querySelectorAll('.nbr');
    elementos.forEach(function(elemento) {
        if (elementoVisivel(elemento) && !elemento.classList.contains('contado')) {
            iniciarContador(elemento);
            elemento.classList.add('contado'); // Marca o elemento como contado
        }
    });
}

// Evento de scroll para verificar visibilidade durante o scroll da página
window.addEventListener('scroll', checarVisibilidade);

// Evento de load para verificar visibilidade ao carregar a página
window.addEventListener('load', checarVisibilidade);

jQuery(function ($) {

    const modal_info = $('#modal-info');
    const loading_cover = $('#loading-cover');

    $('.evento-info').on('click', function (e) {

        e.preventDefault();
        loading_cover.addClass('active');

        $eid = parseInt($(this).attr('data-evento'));
        $data_post = { eid: $eid, action: 'evento_info' };

        $.post(naitech.ajax_url, $data_post, function (data) {
            
            modal_info.html(data);

        }, "html").done(function (data) {
            loading_cover.removeClass('active');
            modal_info.modal('show');
        });

    });

    $('.video-lazy').on('click', function(e){
        e.preventDefault();
        $(this).addClass('loading');
        var iframe = $(this).find('iframe');
        var iframe_src = $(this).find('iframe').attr("src");
        var new_iframe_src = iframe_src.replace('autoplay=0', 'autoplay=1');
        iframe.attr("src", new_iframe_src);
    });

    $('#mobile-menu .menu-item-has-children>a').on('click', function(e){
        e.preventDefault();
        $(this).siblings('.sub-menu').toggleClass('active');
    });

});